import {z} from "zod";
import { dataTableMetaDTOSchema } from "../../pages/Contact/MainDataTable";
 
 

const permissionSchema = z.object({
    isView: z.number().min(0).max(1),
    isEdit: z.number().min(0).max(1).optional(),
    isDelete: z.number().min(0).max(1).optional(),
    isInsert: z.number().min(0).max(1).optional(),
});

const LoyaltyPermissionSchema = z.object({
    vLoyalty: z.object({isView: z.number().min(0).max(1)}),
    campaign: permissionSchema,
    pointSetup: permissionSchema,
});

export type LoyaltyPermissionType = z.infer<typeof LoyaltyPermissionSchema>;

export default LoyaltyPermissionSchema;

const campaignSchema = z.object({
    loyaltyCampaignId: z.number(),
    name: z.string(),
    points: z.number(),
    type: z.string(),
});
export type RowData = z.infer<typeof campaignSchema>;

export const responseSchema = z.object({
    recordsFiltered: z.number(),
    recordsTotal: z.number(),
    draw: z.number(),
    error: z.nullable(z.string()),
    dataTableMetaDTO: dataTableMetaDTOSchema,
    data: z.array(campaignSchema),
});